import { Descope } from '@descope/react-sdk';

function WrappedFlow(props) {
    const { flowId, theme, borderRounded, baseUrl, bgColorHex, validateOnBlur, styleId, onSuccess, onError } = props;
    return (
      <div className={borderRounded ? 'page flow-shown': "page flow-shown rounded-top"} style={bgColorHex ? {"background-color" : "#"+bgColorHex} : {}}  >
          <Descope
            flowId={flowId}
            baseUrl={baseUrl}
            theme={theme}
            styleId={styleId}
            validateOnBlur={String(validateOnBlur)}
            onSuccess={onSuccess}
            onError={onError}
          />
      </div>
    )
  }

  export default WrappedFlow;